/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Form,Space,Row, Col } from 'antd';
import styled, { css } from 'styled-components';
import {
  theme,
  InputComponent,
  Text,
  ButtonAnt,
} from '@pfmam/pfmam';
import { Box, Anchor } from '../../styles/globalStyle';
import { GetBankDetails } from '../../actions/actions';
import { useSelector, useDispatch } from 'react-redux';
import {  isNumber } from '../../utils/common';
import { useHistory,Link } from 'react-router-dom';
import { PlusCircleOutlined } from '@ant-design/icons';
const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;
const ButtonWrapper = styled(Space)`
  justify-content: start;
  width: 100%;
  min-width: 100%;
  margin-top: 16px;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 48px;
    `}
`;
const SearchButtonWrapper= styled(Space)`
  justify-content: space-between;
  width: 100%;
  min-width: 100%;
  margin-top: 16px;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 48px;
    `}
`;
const TextSemibold = styled(Text)`
font-family: 'Inter Semibold';
`;
export const ABALookup = ({accountType,setBankNumbers,setStep}) => {
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [disableSubmit, setdisableSubmit] = useState(true);
  const [form] = Form.useForm();
  const history = useHistory();
  const handleBlur = (e) => {
    const value = e.target.value;
    const name = e.target.getAttribute('data-name');
    const trimmedValue = value.trim();
    form.setFieldsValue({ [name]: trimmedValue });
  }
  const onFinishwithAsync = async (values) => {
      GetBankDetails(values.abaNumber,accountType).then((response) => {
        if (response.data.Table.length > 0) {
          setBankNumbers(response.data.Table)
          setStep(2);
        }
        else{
          form.resetFields();
          setStep(3);
        }
      }).catch((err) => {
        console.log(err);
      });
  };

  const getLabel = () => {
    if (accountType === 'wire') {
      return "Wire ABA Directory";
    } else if (accountType === 'ach') {
      return "ACH ABA Directory";
    } else {
      return "Bank Directory";
    }
  };

  const getplaceholder = () => {
    if (accountType === 'wire') {
      return "Enter Wire ABA";
    } else if (accountType === 'ach') {
      return "Enter ACH ABA";
    } else {
      return "Enter ABA";
    }
  };

  const getInputTextLabel=()=>{
    if (accountType === 'wire') {
      return "Enter 9-digit Wire ABA (routing) number to identify bank";
    } else if (accountType === 'ach') {
      return "Enter 9-digit ACH ABA (routing) number to identify bank";
    } else {
      return "Enter 9-digit number to identify bank";
    }
  }
  return (  
    <Box>
       <Box padding='0 0 0 350px'  margin="0 0 25px" >
 {accountType ==="ach"?<Link
                  to={{
                    pathname: '/aba-lookup/wire',
                  }}
                >
    <ButtonAnt
                    type="link"
                    label="Switch to Wire ABA Directory"
                    onClick={(e) => {
                      setStep(1);
                    }}
                  />
                </Link>:
                
              <Link
                  to={{
                    pathname: '/aba-lookup/ach',
                  }}
                >
    <ButtonAnt
                    type="link"
                    label="Switch to ACH ABA Directory"
                    onClick={(e) => {
                      setStep(1);
                    }}
                  />
                </Link>} 
  </Box>
      <TextSemibold
        label={getLabel()}
        fontSize="25px"
        lineheight="42px"
        color={`${theme.colors.black_secondary}`}
        margin="0 0 32px"
      />
      <Form
        form={form}
        name="basic"
        layout="vertical"
        onFinish={onFinishwithAsync}
        className="forms"
      >
        <Row gutter="10">
          <>
            <Col span={24}>
              <Form.Item
                label={getInputTextLabel()}
                name="abaNumber"
                rules={[
                  {
                    validator: (rule, value) => {
                      if(value!='' && value!=undefined && isNumber(value) && value.length === 9){
                        setdisableSubmit(false);
                        return Promise.resolve()
                      }
                      else if(value.length === 0){
                        setdisableSubmit(true);
                        return Promise.resolve()
                      }
                      else{
                        setdisableSubmit(true);
                       return Promise.reject('Please enter a valid ABA Routing number')
                      }  
                    },
                  },
                ]}
                >
                <InputComponent
                  onBlur={handleBlur}
                  data-name="abaNumber"
                  type="default"
                  placeholder={getplaceholder()}
                  MaxLength="9"
                />
              </Form.Item>
            </Col>
          </>
        </Row>
        <ButtonWrapper size={12}>
          <Anchor
            fontsize={`${theme.font_size.size_l}`}
            lineheight="20px"
            color={`${theme.colors.blue_primay}`}
            display="inline-block"
            onClick={() => {
              form.resetFields();
            }}
          >
            Reset Search
          </Anchor>
        </ButtonWrapper>
        <SearchButtonWrapper size={12} spacing>
        <ButtonAnt
              label="Back"
              type="secondary"
              htmlType="button"
              onClick={() => {
                if(accountType==='wire'){
                  history.push("/settings", { showWirePayeeInformation: true });
                }
                else if(accountType ==='ach'){
                  history.push("/settings",{ showACHPayeeInformation: true });
                }
              }}
            />
          <OverrideButtonAnt
            linkTextColor={primary_color} label="Search" type="primary"
            disabled={disableSubmit}
            htmlType="submit"
          />
        </SearchButtonWrapper>
      </Form>
    </Box>

  );
};